import auth0 from 'auth0-js';

class Auth {
  constructor() {
    this.getProfile = this.getProfile.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
    this.setSettings = this.setSettings.bind(this);
  }

  setSettings(settings) {
    console.log('Auth.setSettings', settings);
    this.settings = settings;
  }

  RedirectURL() {
    console.log('RedirectURL', window.location, process.env);
    return window.location.origin.toLowerCase();
  }
   
  Auth0_BaseAPI(){
    return (undefined === this.settings) ? undefined : this.settings.AUTH0_BASE_API;
  }
 
  Auth0_Domain(){
    if (undefined === this.settings) {
      return undefined;
    }
    return (new URL(this.Auth0_BaseAPI())).hostname;
  }
  
  Auth0_Audience(){
    return (undefined === this.settings) ? undefined : this.settings.AUTH0_AUDIENCE;
  }
  
  Auth0_ClientId(){
    return (undefined === this.settings) ? undefined : this.settings.AUTH0_FRONTEND_CLIENT_ID;
  }
  
  getAuth0() {
    return new auth0.WebAuth({
      domain: this.Auth0_Domain(),
      audience: this.Auth0_Audience(),
      clientID: this.Auth0_ClientId(),
      redirectUri: this.RedirectURL(),
      responseType: 'token id_token',
      scope: 'openid profile email'
    });

  }

  getProfile() {
    return this.profile;
  }

  getIdToken() {
    return this.idToken;
  }

  getAccessToken() {
    return this.accessToken;
  }

  isAuthenticated() {
    const timeNow = new Date().getTime();
    return timeNow < this.expiresAt;
  }

  signIn() {
    this.getAuth0().authorize();
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.getAuth0().parseHash((err, authResult) => {
        if (err) return reject(err);
        if (!authResult || !authResult.idToken) {
          return reject(err);
        }
        this.setSession(authResult);
        resolve();
      });
    })
  }

  setSession(authResult) {
    this.idToken = authResult.idToken;
    this.profile = authResult.idTokenPayload;
    this.accessToken = authResult.accessToken;
    // set the time that the id token will expire at
    this.expiresAt = authResult.idTokenPayload.exp * 1000;
  }

  signOut() {
    this.getAuth0().logout({
      returnTo: this.RedirectURL(),
      clientID: this.Auth0_ClientId(),
    });
  }

  silentAuth() {
    return new Promise((resolve, reject) => {
      this.getAuth0().checkSession({}, (err, authResult) => {
        if (err)
          return reject(err);

        this.setSession(authResult);

        resolve();

      });
    });
  }
}

const auth0Client = new Auth();

export default auth0Client;